import request from 'utils/request';

const queries = {
  create: async (dashboardId, data) =>
    request.post(`/metrics/dashboards/${dashboardId}/queries`, data),
  delete: async (queryId) =>
    await request.delete(`/metrics/queries/${queryId}`),
  get: async (queryId) => await request.get(`/metrics/queries/${queryId}`),
  list: async (dashboardId) =>
    await request.get(`/metrics/dashboards/${dashboardId}/queries`),
  update: async (queryId, data) =>
    await request.patch(`/metrics/queries/${queryId}`, data),
};

const getDashboardKey = (dashboardId) => ['dashboards', dashboardId];
const dashboards = {
  get: async (dashboardId) =>
    await request.get(`/metrics/dashboards/${dashboardId}`),
  list: async () => await request.get('/metrics/dashboards'),
  create: async (data) => await request.post('/metrics/dashboards', data),
  update: async (dashboardId, data) =>
    await request.patch(`/metrics/dashboards/${dashboardId}`, data),
  delete: async (dashboardId) =>
    request.delete(`/metrics/dashboards/${dashboardId}`),
  copyTo: async (data) => await request.post('/metrics/dashboards/copy', data),
};

const authentication = {
  get: async () => await request.get('/metrics/analytics/token'),
};

export default {
  authentication,
  queries,
  dashboards,
  getDashboardKey,
};
